/* eslint-disable no-return-assign */
import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';

const Cards = ({ color, image, title, description, button, onClick }) => (
  <section className="card-default column-reverse">
    <div className="card-img">
      <img src={image} alt="" />
    </div>
    <div className="card-default-item">
      <h5 style={{ color: color.button }}>{title}</h5>
      <p>{description}</p>
    </div>
    <div className="card-default-item">
      {!button.status ? (
        <button
          type="button"
          style={{
            background: color.button,
          }}
          onClick={onClick}
        >
          Saiba mais
        </button>
      ) : (
        <a
          target="_blank"
          href={button.redirectUrl}
          rel="noopener noreferrer"
          style={{
            background: color.button,
          }}
        >
          {button.title}
        </a>
      )}
    </div>
  </section>
);

Cards.propTypes = {
  color: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  button: PropTypes.object.isRequired,
  description: PropTypes.string.isRequired,
};

export default Cards;
